import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { useInsuranceForm } from './useInsuranceForm';
import useGetHaveInsuranceLabel from './useGetHaveInsuranceLabel';
import useGetPrimarySubscriberTitle from './useGetPrimarySubscriberTitle';

import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../constants/formFields';

import { selectCheckInsuranceEligibilityLoading } from '../../redux/appointmentForm/selectors';

const {
  PRIMARY_SUBSCRIBER,
  HEALTH_PLAN,
  MEMBER_ID,
  GROUP_NUMBER,
  DO_NOT_HAVE_INSURANCE,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

const useInsuranceFormManager = ({
  insuranceData,
  userId,
  userName,
  withSelfPayEnding,
  flowType,
}) => {
  const { formatMessage } = useIntl();

  const checkInsuranceLoading = useSelector(
    selectCheckInsuranceEligibilityLoading,
  );

  const {
    formErrors,
    formState,
    handleFormChange,
    isValid,
    setFormErrors,
    validateFormFields,
  } = useInsuranceForm(insuranceData, flowType);

  const haveInsuranceCheckboxLabel = useGetHaveInsuranceLabel({
    formatMessage,
    targetUserName: userName,
    targetUserId: userId,
    withSelfPayEnding,
  });

  const primarySubscriberCheckboxLabel = useGetPrimarySubscriberTitle({
    formatMessage,
    targetUserId: userId,
    targetUserName: userName,
  });

  const userHasNotInsurance = Boolean(formState[DO_NOT_HAVE_INSURANCE]);

  const isPrimarySubscriber = formState[PRIMARY_SUBSCRIBER];

  const handleHealthPlanChange = plan => {
    handleFormChange({
      [HEALTH_PLAN]: plan,
      ...(!plan.id && {
        [MEMBER_ID]: '',
        [GROUP_NUMBER]: '',
      }),
    });
  };

  const onHaveInsuranceChange = value => {
    handleFormChange({
      [DO_NOT_HAVE_INSURANCE]: value,
      [PRIMARY_SUBSCRIBER]: true,
    });
  };

  const onPrimarySubscriberChange = value => {
    handleFormChange({
      [PRIMARY_SUBSCRIBER]: value,
    });
    setFormErrors({});
  };

  const handleChangeField = fieldName => value => {
    handleFormChange({ [fieldName]: value });
    setFormErrors(prev => ({
      ...prev,
      [fieldName]: undefined,
    }));
  };

  return {
    checkInsuranceLoading,
    formErrors,
    formState,
    handleChangeField,
    handleFormChange,
    handleHealthPlanChange,
    haveInsuranceCheckboxLabel,
    isPrimarySubscriber,
    isValid,
    onHaveInsuranceChange,
    onPrimarySubscriberChange,
    primarySubscriberCheckboxLabel,
    userHasNotInsurance,
    validateFormFields,
  };
};

export default useInsuranceFormManager;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useInsuranceFormManager.js